import React from 'react'
import styled, { keyframes } from 'styled-components'
import { IChannel } from 'shared/types/channel'

const fadeIn = keyframes`
    0% { opacity: 0; }
    100% { opacity: 1; }
`

const Container = styled.a`
    height: 160px;
    margin-bottom: 30px;
    width: 100%;
    display: block;
    background-position: center center;
    background-repeat: no-repeat;
    background-size: cover;
    animation: ${fadeIn} 0.333s ease-in forwards;
`
const ChannelBanner = ({ channel }: { channel: IChannel }) => {
    const { banner_image, ancestors, url } = channel
    const rootUrl = `${ancestors && ancestors.length ? ancestors[0].url : url}`
    return banner_image ? (
        <Container
            href={rootUrl}
            style={{
                backgroundImage: `url(${banner_image})`,
            }}
        ></Container>
    ) : null
}

export default ChannelBanner
